import { UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const handleUploadFile = (
  file: File,
  alarmId: string,
  fileUploadMutation: UseMutationResult<
    AxiosResponse<boolean, unknown>,
    unknown,
    { formData: unknown; fileName?: string }
  >,
  onSuccessUpdateFile?: (message: string) => void,
) => {
  const formData = new FormData();

  formData.append('file', file);
  formData.append('key_name', alarmId);
  formData.append('key_type', 'Records');

  fileUploadMutation.mutate(
    { formData, fileName: file.name },
    {
      onSuccess: () => {
        onSuccessUpdateFile && onSuccessUpdateFile(file.name);
      },
    },
  );
};
